let CURRENT_CONSUMER;
let IS_WATCHING = false;
export const setIsWatching = (isWatching) => {
    IS_WATCHING = isWatching;
};
export const setCurrentConsumer = (consumer) => {
    CURRENT_CONSUMER = consumer;
};
export const getCurrentConsumer = () => {
    return CURRENT_CONSUMER;
};
export const getIsWatching = () => {
    return IS_WATCHING;
};
export const untrack = (fn) => {
    const prevConsumer = CURRENT_CONSUMER;
    CURRENT_CONSUMER = undefined;
    try {
        return fn();
    }
    finally {
        CURRENT_CONSUMER = prevConsumer;
    }
};
